import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ar from './locales/ar.json'

export const LOCALE_STORAGE_KEY = 'locale'

export const LOCALES = {
  en: { dir: 'ltr', lang: 'en' },
  ar: { dir: 'rtl', lang: 'ar' }
} as const

export type LocaleKey = keyof typeof LOCALES

export const getSavedLocale = (): LocaleKey => {
  // Prefer the user's saved locale when available.
  if (typeof window === 'undefined') return 'ar'
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
  return stored === 'ar' || stored === 'en' ? stored : 'ar'
}

export const applyDocumentLocale = (locale: LocaleKey) => {
  // Keep <html> and <body> metadata in sync with the active locale.
  if (typeof document === 'undefined') return
  const meta = LOCALES[locale] ?? LOCALES.en
  document.documentElement.setAttribute('dir', meta.dir)
  document.documentElement.setAttribute('lang', meta.lang)
  if (document.body) {
    document.body.setAttribute('dir', meta.dir)
  }
}

export const i18n = createI18n({
  legacy: false,
  locale: getSavedLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    ar
  }
})
